var Shopify = Shopify || {};
const product = JSON.parse(document.querySelector('[data-product-id]').textContent);
const amount_with_comma_separator = '€{{amount_with_comma_separator}}';
const variants = document.querySelectorAll('[data-variant]');
const optionsSize = parseInt(document.querySelector('[data-options-size]').getAttribute('data-options-size'));
const quantityInput = document.querySelector('.quantity-input');
const incrementButton = document.querySelector('.increment-button');
const decrementButton = document.querySelector('.decrement-button');
const crossselling = document.querySelectorAll('.crossselling-product');
const addToCartForm = document.querySelector('form[id="add-to-cart"]');
const stocks = document.querySelectorAll('input[name="variant-stock"]');
const imageWrapper = document.querySelectorAll('.mySwiper2 .swiper-wrapper .swiper-slide');
const variantError = document.querySelector('.variant-error');
const totalVolumeWrapper = document.querySelector('.total-volume');
let firstVariantClick = true;


/* =========================================================
 * Centrale prijsopbouw voor het nieuwe compacte prijsblok.
 *
 * Deze functies wijzigen uitsluitend de zichtbare prijsweergave.
 * De variant-ID, hoofdhoeveelheid en accessoirehoeveelheden die
 * naar /cart/add.js worden gestuurd blijven ongewijzigd.
 * ========================================================= */
function bdPricesIncludeVat() {
  return sessionStorage.getItem('pricesIncludeVat') === 'true';
}

function bdFormatDisplayPrice(priceExclVat) {
  const numericPrice = Number(priceExclVat) || 0;
  const displayPrice = bdPricesIncludeVat()
    ? Math.round(numericPrice * 1.21)
    : Math.round(numericPrice);

  return Shopify.formatMoney(
    displayPrice,
    amount_with_comma_separator,
  );
}

function bdGetEligibleVolumeUnitPrice(baseUnitPrice, quantity) {
  const volumeDiscountSlots = Array.from(
    document.querySelectorAll(
      '#volume-discount-container [data-volume-quantity]',
    ),
  );

  let eligibleSlot = null;
  let highestQuantity = -1;

  volumeDiscountSlots.forEach((slot) => {
    const threshold = Number.parseInt(
      slot.dataset.volumeQuantity || '0',
      10,
    );

    if (
      quantity >= threshold &&
      threshold > highestQuantity
    ) {
      eligibleSlot = slot;
      highestQuantity = threshold;
    }
  });

  volumeDiscountSlots.forEach((slot) => {
    slot.classList.toggle(
      'hover-active',
      slot === eligibleSlot,
    );
  });

  if (!eligibleSlot) {
    return Number(baseUnitPrice) || 0;
  }

  const discountedUnitPrice = Number.parseFloat(
    eligibleSlot.dataset.discountedPrice || '',
  );

  return Number.isFinite(discountedUnitPrice)
    ? discountedUnitPrice
    : Number(baseUnitPrice) || 0;
}

function bdGetAccessoriesTotalExclVat() {
  let accessoriesTotal = 0;

  document
    .querySelectorAll('.crossselling-product')
    .forEach((crosssellProduct) => {
      const accessoryQuantityInput =
        crosssellProduct.querySelector('#quantity-input');

      const accessoryPriceElement =
        crosssellProduct.querySelector(
          '[data-product-price]',
        );

      if (
        !accessoryQuantityInput ||
        !accessoryPriceElement
      ) {
        return;
      }

      const accessoryQuantity = Number.parseInt(
        accessoryQuantityInput.value || '0',
        10,
      );

      const accessoryUnitPrice = Number.parseFloat(
        accessoryPriceElement.getAttribute(
          'data-product-price',
        ) || '0',
      );

      if (
        accessoryQuantity > 0 &&
        Number.isFinite(accessoryUnitPrice)
      ) {
        accessoriesTotal +=
          accessoryUnitPrice * accessoryQuantity;
      }
    });

  return accessoriesTotal;
}

function updateBdPriceSummary() {
  const summary = document.querySelector(
    '[data-bd-price-summary]',
  );

  const currentPrice = document.querySelector(
    '.current-price',
  );

  if (!summary || !currentPrice) {
    return;
  }

  const quantity = Math.max(
    1,
    Number.parseInt(quantityInput?.value || '1', 10) || 1,
  );

  const baseUnitPrice = Number.parseFloat(
    currentPrice.getAttribute('data-solo-price') ||
      currentPrice.getAttribute('data-price') ||
      currentPrice.getAttribute('data-excl-price') ||
      '0',
  );

  const effectiveUnitPrice =
    bdGetEligibleVolumeUnitPrice(
      baseUnitPrice,
      quantity,
    );

  const comparePriceElement = document.querySelector(
    '.total-volume-compare-price, .compare-at-price',
  );

  const configuredComparePrice = Number.parseFloat(
    comparePriceElement?.getAttribute(
      'data-compare-price',
    ) ||
      comparePriceElement?.getAttribute(
        'data-excl-price',
      ) ||
      '0',
  );

  let oldUnitPrice = 0;

  if (effectiveUnitPrice < baseUnitPrice) {
    oldUnitPrice = baseUnitPrice;
  } else if (
    configuredComparePrice > effectiveUnitPrice
  ) {
    oldUnitPrice = configuredComparePrice;
  }

  currentPrice.setAttribute(
    'data-excl-price',
    String(effectiveUnitPrice),
  );
  currentPrice.innerHTML =
    bdFormatDisplayPrice(effectiveUnitPrice);

  if (comparePriceElement) {
    const showComparePrice =
      oldUnitPrice > effectiveUnitPrice;

    comparePriceElement.classList.toggle(
      'hidden',
      !showComparePrice,
    );

    comparePriceElement.setAttribute(
      'aria-hidden',
      showComparePrice ? 'false' : 'true',
    );

    if (showComparePrice) {
      comparePriceElement.setAttribute(
        'data-excl-price',
        String(oldUnitPrice),
      );

      comparePriceElement.innerHTML =
        bdFormatDisplayPrice(oldUnitPrice);
    }
  }

  const mainProductTotal =
    effectiveUnitPrice * quantity;

  const accessoriesTotal =
    bdGetAccessoriesTotalExclVat();

  const grandTotal =
    mainProductTotal + accessoriesTotal;

  const quantityElement = document.querySelector(
    '.total-volume-quantity',
  );

  const mainTotalElement = document.querySelector(
    '.total-volume-totalprice',
  );

  const accessoriesRow = document.querySelector(
    '[data-bd-accessories-row]',
  );

  const accessoriesTotalElement =
    document.querySelector(
      '[data-bd-accessories-total]',
    );

  const grandTotalElement = document.querySelector(
    '[data-bd-grand-total]',
  );

  const totalLabel = document.querySelector(
    '[data-bd-total-label]',
  );

  if (quantityElement) {
    quantityElement.textContent = String(quantity);
  }

  if (mainTotalElement) {
    mainTotalElement.setAttribute(
      'data-excl-price',
      String(mainProductTotal),
    );

    mainTotalElement.innerHTML =
      bdFormatDisplayPrice(mainProductTotal);
  }

  if (accessoriesRow) {
    const hasProductAccessories =
      crossselling.length > 0;

    accessoriesRow.hidden =
      !hasProductAccessories;

    accessoriesRow.setAttribute(
      'aria-hidden',
      hasProductAccessories ? 'false' : 'true',
    );
  }

  if (accessoriesTotalElement) {
    accessoriesTotalElement.setAttribute(
      'data-excl-price',
      String(accessoriesTotal),
    );

    accessoriesTotalElement.innerHTML =
      bdFormatDisplayPrice(accessoriesTotal);
  }

  if (grandTotalElement) {
    grandTotalElement.setAttribute(
      'data-excl-price',
      String(grandTotal),
    );

    grandTotalElement.innerHTML =
      bdFormatDisplayPrice(grandTotal);
  }

  if (totalLabel) {
    totalLabel.textContent = bdPricesIncludeVat()
      ? 'Totaal incl. btw'
      : 'Totaal excl. btw';
  }
}

window.updateBdPriceSummary = updateBdPriceSummary;

function scheduleBdPriceSummaryUpdate() {
  [0, 40, 120, 300].forEach((delay) => {
    window.setTimeout(
      updateBdPriceSummary,
      delay,
    );
  });
}

const productOrderLimit = parseInt(
  document.querySelector('[data-product-orderlimit]')?.getAttribute('data-product-orderlimit') || 1,
  10
);
const variantOrderLimit = document.querySelectorAll('[data-variant-orderlimit]');
const variantOrderLimitMap = {};
var inputChanged = false;
var incrementClicked = false;
var decrementClicked = false;

if (quantityInput) {
  quantityInput.addEventListener('input', () => (inputChanged = true));
}
if (incrementButton) {
  incrementButton.addEventListener('click', () => (incrementClicked = true));
}
if (decrementButton) {
  decrementButton.addEventListener('click', () => (decrementClicked = true));
}

variantOrderLimit.forEach((orderlimit) => {
  const variantOrderLimitId = orderlimit.value;
  const rawValue = orderlimit.getAttribute('data-variant-orderlimit');
  const parsedValue = parseInt(rawValue, 10);

  variantOrderLimitMap[variantOrderLimitId] = !isNaN(parsedValue) ? parsedValue : null;
});

const stocksMap = {};
var currentOptions = {};

stocks.forEach((stock) => {
  const variantId = stock.value;
  const stockValue = parseInt(stock.getAttribute('data-stock'));
  stocksMap[variantId] = stockValue;
});

/*
 * Alle varianten van dezelfde productpagina kunnen samen één samengestelde
 * winkelwagengroep vormen. De groepscode is daarom gebaseerd op product.id
 * en niet op de afzonderlijke variant of de gekozen accessoireset.
 *
 * Zodra bij één variant accessoires worden gekozen, krijgen ook eerder
 * toegevoegde varianten van diezelfde productpagina dezelfde privé-eigenschappen.
 * Bestaande accessoires uit oudere groepen worden daarbij meegenomen. De
 * aantallen, staffels en prijsberekeningen worden niet aangepast.
 */
function bdGetProductGroupId() {
  return `bd-product-${String(product.id)}`;
}

function bdGetCartItemProductId(item) {
  return item?.product_id ?? item?.product?.id ?? '';
}

function bdGetCartItemProperties(item) {
  return item && typeof item.properties === 'object' && item.properties
    ? { ...item.properties }
    : {};
}

function bdBuildGroupProperties(existingProperties, itemType) {
  return {
    ...bdGetCartItemProperties({ properties: existingProperties }),
    _bd_group_id: bdGetProductGroupId(),
    _bd_item_type: itemType,
    _bd_parent_product_id: String(product.id),
  };
}

async function bdFetchCurrentCart() {
  const response = await fetch('/cart.js', { cache: 'no-store' });

  if (!response.ok) {
    throw new Error(`Cart ophalen mislukt (${response.status})`);
  }

  return response.json();
}

async function bdChangeCartLineProperties(lineItem, properties) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItem.key,
      quantity: Number.parseInt(lineItem.quantity, 10),
      properties,
    }),
  });

  if (!response.ok) {
    throw new Error(`Winkelwagenregel bijwerken mislukt (${response.status})`);
  }

  return response.json();
}

/*
 * forceGroup is true zodra de bezoeker nu accessoires toevoegt. Is er al een
 * oudere groep voor dezelfde productpagina aanwezig, dan wordt die eveneens
 * naar de vaste productgroep gemigreerd. Door na iedere wijziging de door
 * Shopify teruggegeven cart te gebruiken, blijven veranderde line keys veilig.
 */
async function bdPrepareProductGroup(forceGroup) {
  const canonicalGroupId = bdGetProductGroupId();
  const currentProductId = String(product.id);

  try {
    let cart = await bdFetchCurrentCart();

    const currentProductMainLines = (cart.items || []).filter((item) => {
      const properties = item.properties || {};
      return (
        String(bdGetCartItemProductId(item)) === currentProductId &&
        properties._bd_item_type !== 'accessory'
      );
    });

    const relatedGroupIds = new Set([canonicalGroupId]);

    currentProductMainLines.forEach((item) => {
      const groupId = item.properties?._bd_group_id;
      if (groupId) {
        relatedGroupIds.add(String(groupId));
      }
    });

    const hasExistingGroup = currentProductMainLines.some((item) => {
      return Boolean(item.properties?._bd_group_id);
    });

    const hasRelatedAccessory = (cart.items || []).some((item) => {
      const properties = item.properties || {};
      const groupId = String(properties._bd_group_id || '');
      const parentProductId = String(
        properties._bd_parent_product_id || '',
      );

      return (
        properties._bd_item_type === 'accessory' &&
        (
          relatedGroupIds.has(groupId) ||
          parentProductId === currentProductId
        )
      );
    });

    const shouldUseGroup =
      forceGroup || hasExistingGroup || hasRelatedAccessory;

    if (!shouldUseGroup) {
      return null;
    }

    const maxMigrations = Math.max((cart.items || []).length * 3, 12);

    for (let migrationIndex = 0; migrationIndex < maxMigrations; migrationIndex += 1) {
      const lineToMigrate = (cart.items || []).find((item) => {
        const properties = item.properties || {};
        const itemProductId = String(bdGetCartItemProductId(item));
        const groupId = String(properties._bd_group_id || '');
        const parentProductId = String(
          properties._bd_parent_product_id || '',
        );

        const isCurrentProductMain =
          itemProductId === currentProductId &&
          properties._bd_item_type !== 'accessory';

        const isRelatedAccessory =
          properties._bd_item_type === 'accessory' &&
          (
            relatedGroupIds.has(groupId) ||
            parentProductId === currentProductId
          );

        if (!isCurrentProductMain && !isRelatedAccessory) {
          return false;
        }

        const desiredType = isRelatedAccessory ? 'accessory' : 'main';

        return (
          groupId !== canonicalGroupId ||
          properties._bd_item_type !== desiredType ||
          parentProductId !== currentProductId
        );
      });

      if (!lineToMigrate) {
        break;
      }

      const lineProperties = lineToMigrate.properties || {};
      const desiredType =
        lineProperties._bd_item_type === 'accessory'
          ? 'accessory'
          : 'main';

      cart = await bdChangeCartLineProperties(
        lineToMigrate,
        bdBuildGroupProperties(lineProperties, desiredType),
      );
    }

    return bdBuildGroupProperties({}, 'main');
  } catch (error) {
    console.warn(
      'Bestaande productregels konden niet volledig worden gegroepeerd:',
      error,
    );

    return forceGroup
      ? bdBuildGroupProperties({}, 'main')
      : null;
  }
}

/*
 * Na een geslaagde toevoeging wordt de configurator klaargezet voor een
 * volgende variant. Het hoofdproduct gaat terug naar de geldende minimale
 * bestelhoeveelheid. Accessoires gaan terug naar 0, zodat ze niet onbedoeld
 * opnieuw aan een volgende hoofdvariant worden toegevoegd.
 */
function bdResetProductConfiguratorAfterAdd(variantId) {
  const activeLimit = getActiveOrderLimit(
    variantOrderLimitMap,
    variantId,
  );

  if (quantityInput) {
    quantityInput.value = activeLimit;
    quantityInput.min = activeLimit;
  }

  const quantityField = document.querySelector(
    'input[name="quantity-second"]',
  );

  if (quantityField) {
    quantityField.value = activeLimit;
  }

  inputChanged = false;
  incrementClicked = false;
  decrementClicked = false;

  crossselling.forEach((crosssellProduct) => {
    crosssellProduct.dispatchEvent(
      new CustomEvent('bd:reset-crosssell-quantity'),
    );
  });

  if (currentOptions) {
    updateCurrentOptions(currentOptions, false);
  } else {
    initializeLimits(productOrderLimit, null, null);
  }

  scheduleBdPriceSummaryUpdate();
}

// Add to cart
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async function (event) {
    event.preventDefault();
    const formData = new FormData(addToCartForm);
    const productId = formData.get('id');
    const productQty = formData.get('quantity-second');

    const selectedAccessories = [];

    crossselling.forEach(function (product) {
      const variantId = product.getAttribute('data-variant-id');
      const crossellingQty = product.querySelector('#quantity-input').value;

      if (crossellingQty > 0) {
        selectedAccessories.push({
          id: variantId,
          quantity: parseInt(crossellingQty, 10),
        });
      }
    });

    const groupProperties = await bdPrepareProductGroup(
      selectedAccessories.length > 0,
    );

    const mainItem = {
      id: productId,
      quantity: parseInt(productQty, 10),
    };

    if (groupProperties) {
      mainItem.properties = groupProperties;
    }

    const items = [mainItem];

    if (selectedAccessories.length > 0) {
      selectedAccessories.forEach((accessory) => {
        items.push({
          ...accessory,
          properties: bdBuildGroupProperties({}, 'accessory'),
        });
      });
    }

    /*
     * Shopify plaatst de regels uit een meervoudige /cart/add.js-aanroep
     * in omgekeerde volgorde in cart.items. De logische items-array blijft
     * hoofdproduct-eerst voor de bevestigingspopup. Alleen de payload naar
     * Shopify wordt daarom omgedraaid. De winkelwagenweergave sorteert daarna
     * binnen iedere groep alle hoofdproducten vóór de accessoires.
     */
    const cartItems = [...items].reverse();

    if (isNaN(parseInt(productId, 10))) {
      if (variantError.classList.contains('hidden')) {
        variantError.classList.remove('hidden');
        variantError.classList.add('flex');
      }
      return;
    }

    if (!isNaN(parseInt(productQty, 10))) {
      if (variantError.classList.contains('flex')) {
        variantError.classList.remove('flex');
        variantError.classList.add('hidden');
      }
      if (items) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: cartItems }),
        })
          .then(async (response) => {
            const data = await response.json();

            if (!response.ok) {
              const message =
                data?.description ||
                data?.message ||
                `Toevoegen mislukt (${response.status})`;

              throw new Error(message);
            }

            return data;
          })
          .then((data) => {
            showCartNotification(data, items);
            updateSmallcart();
            bdResetProductConfiguratorAfterAdd(productId);
            setTimeout(function () {
              hideCartNotification();
            }, 3000);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    } else {
      if (variantError.classList.contains('hidden')) {
        variantError.classList.remove('hidden');
        variantError.classList.add('flex');
      }
    }
  });
}

// Variants
if (variants) {
  variants.forEach((variant) => {
    ['click', 'change'].forEach((eventName) => {
      variant.addEventListener(eventName, (event) => {
        handleVariantChange(variant, event.type);
      });
    });
  });
}

// Crossselling
if (crossselling) {
  crossselling.forEach(function (product) {
    handleCrosssellingChange(product);
  });
}

document.addEventListener('click', function (event) {
  const e = event.target.closest('[data-volume-quantity]');
  if (!e) return;

  if (!quantityInput) return;

  const volume_quantity = e.getAttribute('data-volume-quantity');
  const volume_price = e.getAttribute('data-discounted-price');
  const volume_current_price = document.querySelector('.current-price');

  volume_current_price.setAttribute('data-price', volume_price);
  quantityInput.value = parseInt(volume_quantity, 10);

  if (currentOptions) {
    updateCurrentOptions(currentOptions, false);
  }

  scheduleBdPriceSummaryUpdate();
});

// Init the first variants so the quantity and prices updates
initializeVariantsWithoutActive();

// First init of the limits of the products
initializeLimits(productOrderLimit, null, null);

function getActiveOrderLimit(variantOrderLimit, variantId) {
  let activeLimit = productOrderLimit > 0 ? productOrderLimit : 1;

  if (
    variantOrderLimit !== null &&
    variantId !== null &&
    variantOrderLimit[variantId] !== undefined &&
    variantOrderLimit[variantId] !== null &&
    !isNaN(parseInt(variantOrderLimit[variantId], 10))
  ) {
    const variantLimit = parseInt(variantOrderLimit[variantId], 10);

    if (variantLimit > 0) {
      activeLimit = variantLimit;
    }
  }

  if (activeLimit < 1 || isNaN(activeLimit)) {
    activeLimit = 1;
  }

  return activeLimit;
}

function initializeLimits(productOrderLimitParam, variantOrderLimitParam, variantId) {
  if (!quantityInput) return;

  const orderLimitText = document.querySelector('.orderlimit-text');
  const activeLimit = getActiveOrderLimit(variantOrderLimitParam, variantId);
  let currentQty = parseInt(quantityInput.value || activeLimit, 10);

  if (isNaN(currentQty) || currentQty < activeLimit) {
    currentQty = activeLimit;
    quantityInput.value = activeLimit;
  }

  quantityInput.min = activeLimit;

  if (orderLimitText) {
    if (activeLimit > 1 && currentQty === activeLimit) {
      orderLimitText.classList.remove('hidden');
    } else {
      orderLimitText.classList.add('hidden');
    }
  }
}

function initializeVariantsWithoutActive() {
  const optionNames = ['option1', 'option2', 'option3'];

  optionNames.forEach((optionName) => {
    var option = document.querySelector(`[name="${optionName}"]`);
    if (option) {
      if (option.tagName == 'INPUT') {
        var optionValue = document.querySelector(`[name="${optionName}"]`).getAttribute('data-value');
        var parent = option.parentElement;
        if (!parent.classList.contains('variant-active')) {
          currentOptions[optionName] = optionValue;
        }
      }
if (option.tagName == 'SELECT') {
  option.value = '';
  currentOptions[optionName] = '';
}
    }
  });

  if (currentOptions) {
    updateCurrentOptions(currentOptions, false);
  }
}

function initializeVariants() {
  const optionNames = ['option1', 'option2', 'option3'];

  optionNames.forEach((optionName) => {
    var option = document.querySelector(`[name="${optionName}"]`);
    if (option) {
      if (option.tagName == 'INPUT') {
        var optionValue = document.querySelector(`[name="${optionName}"]`).getAttribute('data-value');
        var parent = option.parentElement;
        if (!parent.classList.contains('variant-active')) {
          parent.classList.add('variant-active');
          currentOptions[optionName] = optionValue;
        }
      }
      if (option.tagName == 'SELECT') {
  option.value = '';
  currentOptions[optionName] = '';
}
    }
  });

  if (currentOptions) {
    updateCurrentOptions(currentOptions, true);
  }
}

function handleVariantChange(variant, eventType) {
  if (firstVariantClick) {
    for (const key in currentOptions) {
      currentOptions[key] = '';
    }
    firstVariantClick = false;
  }

  const optionName = variant.getAttribute('data-name');
  let optionValue = null;

  if (variant.tagName == 'SELECT') {
  const selectedOption = variant.options[variant.selectedIndex];

  if (!variant.value || !selectedOption || !selectedOption.getAttribute('data-value')) {
    currentOptions[optionName] = '';
    return;
  }

  optionValue = selectedOption.getAttribute('data-value');
} else {
  optionValue = variant.getAttribute('data-value');
}

  if (optionValue !== null) {
    currentOptions[optionName] = optionValue;

    if (variant.tagName == 'INPUT') {
      var allInputs = document.querySelectorAll(`[name="${optionName}"]`);
      var input = document.querySelector(`[name="${optionName}"][data-value="${currentOptions[optionName]}"]`);

      if (input) {
        var label = input.parentElement;

        allInputs.forEach((item) => {
          var parentItem = item.parentElement;
          parentItem.classList.remove('variant-active');
        });

        label.classList.add('variant-active');
      }
    }

    if (currentOptions) {
      /*
       * Alleen een echte wijziging mag de mobiele afbeelding-popup
       * activeren. Een klik waarmee een dropdown alleen wordt geopend
       * mag dat niet doen.
       */
      const showVariantPreview = eventType === 'change';

      updateCurrentOptions(
        currentOptions,
        true,
        showVariantPreview,
      );
    }
  }
}

function handleCrosssellingChange(product) {
  const incrementButton = product.querySelector('#increment-button');
  const decrementButton = product.querySelector('#decrement-button');
  const quantityInput = product.querySelector('#quantity-input');
  const productPriceElement = product.querySelector('[data-product-price]');
  var basePrice = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;
  var basePriceExcl = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;
  var quantity = 0;
  var totalPrice = basePrice;

  function updateQuantityAndPrice() {
    quantityInput.value = quantity;
    if (quantity > 0) {
      if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
        totalPrice = basePrice * 1.21 * quantity;
      } else {
        totalPrice = basePrice * quantity;
      }
      totalPriceExcl = basePriceExcl * quantity;
    } else {
      if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
        totalPrice = basePrice * 1.21 * 1;
      } else {
        totalPrice = basePrice * 1;
      }
      totalPriceExcl = basePriceExcl * 1;
    }
    productPriceElement.setAttribute('data-excl-price', totalPriceExcl * 100);
    productPriceElement.innerHTML = Shopify.formatMoney(Math.round(totalPrice * 100), '€{{amount_with_comma_separator}}');
    decrementButton.disabled = quantity === 0;
    updatePriceWithCrossselling();
  }

  incrementButton.addEventListener('click', () => {
    quantity += 1;
    updateQuantityAndPrice();
  });

  decrementButton.addEventListener('click', () => {
    if (quantity > 0) {
      quantity -= 1;
      updateQuantityAndPrice();
    }
  });

  product.addEventListener('bd:reset-crosssell-quantity', () => {
    quantity = 0;
    updateQuantityAndPrice();
  });
}

function getSelectedOptionValue(currentOptionsParam, optionPosition) {
  const optionName = `option${optionPosition}`;
  const selectedValue = currentOptionsParam[optionName] || '';

  if (selectedValue) {
    return selectedValue;
  }

  /*
   * Shopify geeft een product zonder echte opties technisch
   * de waarde "Default Title".
   */
  if (
    optionPosition === 1 &&
    optionsSize === 1 &&
    product.variants.some((variant) => variant.option1 === 'Default Title')
  ) {
    return 'Default Title';
  }

  return '';
}

function getMatchingVariants(currentOptionsParam) {
  return product.variants.filter((variant) => {
    for (let optionPosition = 1; optionPosition <= optionsSize; optionPosition += 1) {
      const selectedValue = getSelectedOptionValue(
        currentOptionsParam,
        optionPosition,
      );

      if (
        selectedValue &&
        variant[`option${optionPosition}`] !== selectedValue
      ) {
        return false;
      }
    }

    return true;
  });
}

function isVariantSelectionComplete(currentOptionsParam) {
  for (let optionPosition = 1; optionPosition <= optionsSize; optionPosition += 1) {
    if (!getSelectedOptionValue(currentOptionsParam, optionPosition)) {
      return false;
    }
  }

  return true;
}

function getLowestPricedVariant(matchingVariants) {
  if (!matchingVariants.length) {
    return null;
  }

  return matchingVariants.reduce((lowestVariant, variant) => {
    return Number(variant.price) < Number(lowestVariant.price)
      ? variant
      : lowestVariant;
  });
}

function updatePriceFromLabelVisibility(selectionComplete) {
  document.querySelectorAll('.price-from-label').forEach((label) => {
    label.style.display = selectionComplete ? 'none' : '';
  });
}

/*
 * Bij een gedeeltelijke keuze tonen we de laagste prijs van alle
 * varianten die nog bij de reeds gekozen opties passen.
 *
 * De variant-ID, voorraadstatus en productafbeelding worden hierbij
 * bewust nog niet aangepast. Dat gebeurt pas na de volledige keuze.
 */
function updatePartialVariantPrice(variant) {
  if (!variant) {
    return;
  }

  const currentPrice = document.querySelector('.current-price');
  const volumeTotalPrice = document.querySelector('.total-volume-totalprice');
  const quantity = parseInt(quantityInput?.value || 1, 10);
  const priceExcl = Number(variant.price || 0);

  if (!currentPrice || !priceExcl) {
    return;
  }

  currentPrice.setAttribute('data-solo-price', priceExcl);
  currentPrice.setAttribute('data-price', priceExcl);
  currentPrice.setAttribute('data-stock', '');
  currentPrice.setAttribute('data-excl-price', priceExcl);

  let displayedUnitPrice = priceExcl;

  if (sessionStorage.getItem('pricesIncludeVat') === 'true') {
    displayedUnitPrice = Math.round(displayedUnitPrice * 1.21);
  }

  currentPrice.innerHTML = Shopify.formatMoney(
    displayedUnitPrice,
    amount_with_comma_separator,
  );

  if (volumeTotalPrice) {
    const totalPriceExcl = priceExcl * quantity;
    let displayedTotalPrice = totalPriceExcl;

    volumeTotalPrice.setAttribute(
      'data-excl-price',
      totalPriceExcl,
    );

    if (sessionStorage.getItem('pricesIncludeVat') === 'true') {
      displayedTotalPrice = Math.round(displayedTotalPrice * 1.21);
    }

    volumeTotalPrice.innerHTML = Shopify.formatMoney(
      displayedTotalPrice,
      amount_with_comma_separator,
    );
  }

  updateBdPriceSummary();
}

function updateCurrentOptions(
  currentOptions,
  showVariantImage,
  showVariantPreview = false,
) {
  const matchingVariants = getMatchingVariants(currentOptions);
  const selectionComplete = isVariantSelectionComplete(currentOptions);

  /*
   * Na een volledige keuze blijft de bestaande exacte variantlogica
   * leidend voor prijs, voorraad, afbeelding, barcode en bestellimiet.
   */
  if (selectionComplete && matchingVariants[0] !== undefined) {
    const currentOption = matchingVariants[0];
    var id = currentOption.id;
    var price = currentOption.price;
    var compare_at_price = currentOption.compare_at_price;
    var stock = stocksMap[id] || 0;
    var barcode = currentOption.barcode;

    updatePriceWithStock(
      price,
      compare_at_price,
      stock,
      id,
      showVariantImage,
      showVariantPreview,
    );
    updateBarcode(barcode);
    updatePriceFromLabelVisibility(true);

    if (totalVolumeWrapper) {
      updateTotalVolumeElement();
    }

    initializeLimits(null, variantOrderLimitMap, id);
    return;
  }

  /*
   * Bij een gedeeltelijke keuze tonen we direct de laagste prijs
   * binnen de nog mogelijke variantcombinaties.
   */
  const lowestMatchingVariant = getLowestPricedVariant(
    matchingVariants,
  );

  if (lowestMatchingVariant) {
    updatePartialVariantPrice(lowestMatchingVariant);
  }

  updatePriceFromLabelVisibility(false);

  if (totalVolumeWrapper) {
    updateTotalVolumeElement();
  } else {
    updatePriceWithDiscounts();
  }

  initializeLimits(productOrderLimit, null, null);
}

function updatePriceWithDiscounts() {
  updateBdPriceSummary();
}

function updateTotalVolumeElement() {
  window.setTimeout(function () {
    updateBdPriceSummary();
  }, 250);
}

function updatePriceWithStock(
  price,
  compare_at_price,
  stock,
  id,
  showVariantImage,
  showVariantPreview = false,
) {
  const volumeDiscountContainer = document.querySelector('#volume-discount-container');
  var priceExcl = price;
  var comparePriceExcl = compare_at_price;
  var discountedPriceExcl = 0;

  if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
    compare_at_price = compare_at_price * 1.21;
  }

  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.querySelector('.compare-at-price');
  const quantity = parseInt(quantityInput?.value || 1, 10);
  var totalPrice = price;

  if (sessionStorage.getItem('pricesIncludeVat') == 'true') {
    totalPrice = totalPrice * 1.21;
  }

  var totalPriceExcl = priceExcl;
  var totalComparePrice = compare_at_price;
  var totalComparePriceExcl = comparePriceExcl;

  if (currentPrice) {
    currentPrice.setAttribute('data-solo-price', price);
    currentPrice.setAttribute('data-price', priceExcl);
    currentPrice.setAttribute('data-stock', stock);
    currentPrice.setAttribute('data-excl-price', totalPriceExcl);
    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-excl-price', totalComparePriceExcl);
      currentComparePrice.setAttribute('data-compare-price', totalComparePriceExcl);
    }
  }

  setTimeout(() => {
    if (volumeDiscountContainer) {
      var volumeDiscountSlots = document.querySelectorAll('#volume-discount-container [data-volume-quantity]');
      volumeDiscountSlots.forEach((el) => {
        var dataVolumeQty = parseInt(el.dataset.volumeQuantity);
        var dataDiscountedPrice = el.dataset.discountedPrice;
        if (quantity >= dataVolumeQty) {
          discountedPriceExcl = parseFloat(dataDiscountedPrice);
        }
      });
    }

    const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
    const prettyComparePrice = Shopify.formatMoney(totalComparePrice, amount_with_comma_separator);
    const prettyDiscountedPrice = Shopify.formatMoney(discountedPriceExcl, amount_with_comma_separator);

    if (currentPrice) {
      if (!volumeDiscountContainer) {
        currentPrice.innerHTML = `${prettyPrice}`;
      } else {
        if (discountedPriceExcl > 0) {
          currentPrice.innerHTML = `${prettyDiscountedPrice}`;
        } else {
          currentPrice.innerHTML = `${prettyPrice}`;
        }
      }
    }

    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-compare-price', totalComparePriceExcl);
      currentComparePrice.setAttribute('data-excl-price', totalComparePriceExcl);
      currentComparePrice.innerHTML = `${prettyComparePrice}`;
    }

    updateBdPriceSummary();

    const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
    const outOfStockBtn = document.querySelector('[data-out-of-stock-button]');
    const toggleClass = (element, removeClass, addClass) => {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    };

    if (stock <= 0 || stock < quantity) {
      toggleClass(addToCartBtn, 'flex', 'hidden');
      toggleClass(outOfStockBtn, 'hidden', 'flex');
    } else {
      toggleClass(addToCartBtn, 'hidden', 'flex');
      toggleClass(outOfStockBtn, 'flex', 'hidden');
    }

    if (showVariantImage) {
      var variantId = document.querySelector(`input[name="id"]`);
      variantId.value = id;
    }

    var quantityField = document.querySelector(`input[name="quantity-second"]`);
    quantityField.value = quantity;

    const variantDataInput = document.querySelector(
      `input[name="variant-stock"][value="${id}"]`,
    );

    const selectedImage = variantDataInput?.getAttribute(
      'data-image',
    );

    const hasOwnVariantImage =
      variantDataInput?.getAttribute(
        'data-has-variant-image',
      ) === 'true';

    if (showVariantImage && selectedImage) {
      const normalize = (url) => {
        if (!url) return '';
        const abs = String(url).startsWith('//') ? location.protocol + url : String(url);
        return abs.split('?')[0];
      };

      const target = normalize(selectedImage);
      const mainImgs = [...document.querySelectorAll('.mySwiper2 .swiper-slide img')];
      const targetIndex = mainImgs.findIndex((img) => normalize(img.getAttribute('src')) === target);
      const mainSwiperEl = document.querySelector('.mySwiper2');
      const mainSwiper = mainSwiperEl?.swiper;

      if (mainSwiper && targetIndex >= 0) {
        mainSwiper.slideTo(targetIndex, 300);
      }
    }

    /*
     * De popup is uitsluitend bedoeld voor de eenkolomsweergave.
     * Alleen varianten met een eigen gekoppelde afbeelding sturen
     * het event door. De popup zelf wordt in em-main-product beheerd.
     */
    if (
      showVariantImage &&
      showVariantPreview &&
      hasOwnVariantImage &&
      selectedImage &&
      window.matchMedia('(max-width: 1023px)').matches
    ) {
      document.dispatchEvent(
        new CustomEvent('bd:variant-image-selected', {
          detail: {
            variantId: String(id),
            imageUrl: selectedImage,
          },
        }),
      );
    }

    if (false) {
      var legacySelectedImage = document.querySelector(`input[value="${id}"]`).getAttribute('data-image');
      if (showVariantImage) {
        if (legacySelectedImage) {
          imageWrapper.forEach((image) => {
            if (image.classList.contains('swiper-slide-active')) {
              let activeImage = image;
              let activeImageWrapper = activeImage.querySelector('img');
              activeImageWrapper.src = legacySelectedImage;
            }
          });
        }
      }
    }

    if (variantError.classList.contains('flex')) {
      variantError.classList.remove('flex');
      variantError.classList.add('hidden');
    }
  }, 250);
}

function updatePriceWithCrossselling() {
  updateBdPriceSummary();
}

function setupQuantityControls() {
  if (!quantityInput) return;

  quantityInput.addEventListener('change', () => {
    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    } else {
      initializeLimits(productOrderLimit, null, null);
    }
  });

  quantityInput.addEventListener('input', () => {
    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    } else {
      initializeLimits(productOrderLimit, null, null);
    }
  });

  incrementButton.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value || 1, 10);
    quantityInput.value = currentValue + 1;

    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    } else {
      initializeLimits(productOrderLimit, null, null);
    }
  });

  decrementButton.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value || 1, 10);
    const minValue = parseInt(quantityInput.min || 1, 10);

    if (currentValue > minValue) {
      quantityInput.value = currentValue - 1;
    } else {
      quantityInput.value = minValue;
    }

    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    } else {
      initializeLimits(productOrderLimit, null, null);
    }
  });
}

function showCartNotification(shoppingcart, added) {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  const products = shoppingcart.items;
  const added_products = added;
  const notification_products = [];

  cart_notification.forEach((cartNotification) => {
    if (cartNotification.classList.contains('hidden')) {
      cartNotification.classList.remove('hidden');
    }
  });

  if ('items' in shoppingcart) {
    /*
     * De popup volgt bewust de logische toevoegvolgorde:
     * eerst het hoofdproduct en daarna de accessoires. De response van
     * Shopify kan door de omgedraaide cart-payload een andere volgorde
     * hebben, daarom zoeken we per toegevoegd item het responseproduct op.
     */
    added_products.forEach((item) => {
      const matchingProduct = products.find(
        (product) => String(product.id) === String(item.id),
      );

      if (!matchingProduct) {
        return;
      }

      notification_products.push({
        quantity: item.quantity,
        title: matchingProduct.product_title,
      });
    });

    if (notification_products.length > 0) {
      var div = document.createElement('div');
      div.className = 'bg-mediocre rounded-[3px] py-6 px-6';
      div.style.backgroundColor = '#e2e2e2';
      div.style.border = '1px solid #c8c8c8';
      div.style.boxSizing = 'border-box';
      var h3 = document.createElement('h3');
      h3.className = 'mb-4 text-lg leading-normal font-bold text-highlight_light';
      h3.textContent = 'Toegevoegd!';
      var ul = document.createElement('ul');
      notification_products.forEach((item) => {
        var li = document.createElement('li');
        li.className = 'text-sm mb-2 text-highlight_dark';
        li.textContent = item.quantity + ' x ' + item.title;
        ul.appendChild(li);
      });
      var span = document.createElement('span');
      span.className = 'block bg-highlight_light text-highlight_dark font-bold text-center py-2 rounded-[3px] mt-6';
      span.textContent = 'Ga naar winkelwagen';
      div.appendChild(h3);
      div.appendChild(ul);
      div.appendChild(span);
      cart_notification.forEach((cartNotification) => {
        cartNotification.appendChild(div.cloneNode(true));
      });
    }
  } else {
    var div = document.createElement('div');
    div.className = 'bg-mediocre rounded-[3px] py-6 px-6';
    div.style.backgroundColor = '#e2e2e2';
    div.style.border = '1px solid #c8c8c8';
    div.style.boxSizing = 'border-box';
    var h3 = document.createElement('h3');
    h3.className = 'mb-4 text-lg leading-normal font-bold text-highlight_light';
    h3.textContent = 'Niet toegevoegd!';
    var p = document.createElement('p');
    p.textContent = shoppingcart.message;
    var span = document.createElement('span');
    span.className = 'block bg-highlight_light text-highlight_dark font-bold text-center py-2 rounded-[3px] mt-6';
    span.textContent = 'Ga naar winkelwagen';
    div.appendChild(h3);
    div.appendChild(p);
    div.appendChild(span);
    cart_notification.forEach((cartNotification) => {
      cartNotification.appendChild(div.cloneNode(true));
    });
  }
}

function hideCartNotification() {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  cart_notification.forEach((cartNotification) => {
    cartNotification.classList.add('hidden');
    cartNotification.innerHTML = '';
  });
}

function updateBarcode(barcode) {
  const barcode_wrapper = document.querySelector('.barcode');
  if (barcode_wrapper) {
    barcode_wrapper.innerHTML = barcode;
  }
}

async function updateSmallcart() {
  const cart_count = document.querySelector('.cart-count p');

  try {
    const cart = await fetchCartItems();

    if (cart) {
      const item_count = cart.item_count;
      cart_count.textContent = item_count;
    }
  } catch (error) {
    console.error('Error updating small cart:', error);
  }
}

async function fetchCartItems() {
  try {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error('Something wrongs');
    }
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      console.log('Empty cart, refetching...');
      return await fetchCartItems();
    }
    return cart;
  } catch (error) {
    console.error('Fetch error:', error);
  }
}


document.addEventListener(
  'bd:crosssell-price-changed',
  scheduleBdPriceSummaryUpdate,
);

document.addEventListener('click', function (event) {
  if (
    event.target.closest?.(
      'input[name="vat-switcher"], .vat-switcher-toggle',
    )
  ) {
    scheduleBdPriceSummaryUpdate();
  }
});

document.addEventListener('change', function (event) {
  if (event.target.matches?.('input[name="vat-switcher"]')) {
    scheduleBdPriceSummaryUpdate();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  setupQuantityControls();
  scheduleBdPriceSummaryUpdate();
});

window.addEventListener(
  'pageshow',
  scheduleBdPriceSummaryUpdate,
);
